/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { injectable, inject } from 'inversify';
import HttpClient from './http.service';

@injectable()
export default class BossReportService {
  @inject(HttpClient)
  protected http!: HttpClient;

  async bossReport() {
    const res = (await this.http.get(`boss/report`)) as string;
    return res;
  }
}
